module.exports = __webpack_public_path__ + "static/media/branding-img12.998aac7d.jpg";